module.exports = __webpack_public_path__ + "static/media/ill_klamydia.17902643.svg";